import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from "ngx-spinner";
import { Router } from "@angular/router";
import { AuthenticationService } from '../../services';
import { TimersService } from '../../services/centralization/timers.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-login',
  imports: [CommonModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent implements OnInit {
  incorrecto: boolean = false;
  isMobileView: boolean = false;

  constructor(
    private authenticationService: AuthenticationService,
    private timersService: TimersService,
    private spinner: NgxSpinnerService,
    private router: Router
  ) { }

  ngOnInit() {
    this.checkIfMobile();
    window.addEventListener('resize', () => this.checkIfMobile());

    if (!this.authenticationService.isLoggedIn()) {
      return;
    } 

    this.spinner.show();

    this.authenticationService.setUser()
      .then(() => {

        this.timersService.startTimerToken();
        this.router.navigate(['/home']);
        this.spinner.hide();
      })
      .catch(() => {
        this.spinner.hide();
        this.router.navigate(['/not-authorized']);
      });
  }

  checkIfMobile(): void {
    const mobileWidth = 571; // Ancho máximo para considerar móvil
    this.isMobileView = window.innerWidth <= mobileWidth;
  }

  login() {
    console.log('Iniciando proceso de login...');
    const url = this.authenticationService.login();
  }

  loginPrueba() {
    this.router.navigate(['process-list']);
  }

}
